import axios from "axios";
import HostService from "../../../services/host.service";
import AuthService from "../../../services/auth.service";

/**
 * Servicio para el endpoint /reponedores (asignaciones de reponedores a almacenes)
 * API documentada en ../api/docs/api/reponedores.md
 */
class ReponedoresService {

    /**
     * GET /reponedores - lista todas las asignaciones
     * @param {Object} params - Parámetros opcionales de filtrado
     * @returns {Promise<Array>} Array de asignaciones
     */
    static async list(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const url = HostService.getHost() + 'reponedores' + (queryString ? `?${queryString}` : '');

        return axios
            .get(url, AuthService.setToken())
            .then((res) => {
                // La API retorna { data: [...], message: "..." }
                const items = res.data?.data ?? [];
                return Array.isArray(items) ? items : [];
            })
            .catch((e) => { console.log(e.message); throw e; });
    }

    /**
     * GET /reponedores/:id - obtiene una asignación por ID
     * @param {number} id - ID de la asignación
     * @returns {Promise<Object>} Asignación encontrada
     */
    static async getById(id) {
        return axios
            .get(HostService.getHost() + 'reponedores/' + encodeURIComponent(id), AuthService.setToken())
            .then((res) => res.data?.data ?? res.data)
            .catch((e) => { console.log(e.message); throw e; });
    }

    /**
     * POST /reponedores - crea una nueva asignación
     * @param {Object} reponedor - Datos de la asignación (almacenes, usuarios)
     * @returns {Promise<Object>} Asignación creada
     */
    static async create(reponedor) {
        return axios
            .post(HostService.getHost() + 'reponedores', reponedor, AuthService.setToken())
            .then((res) => res.data?.data ?? res.data)
            .catch((e) => { console.log(e.message); throw e; });
    }

    /**
     * PUT /reponedores/:id - actualiza una asignación (replace completo de relaciones)
     * @param {number} id - ID de la asignación
     * @param {Object} reponedor - Datos actualizados (almacenes, usuarios)
     * @returns {Promise<Object>} Asignación actualizada
     */
    static async update(id, reponedor) {
        return axios
            .put(
                HostService.getHost() + 'reponedores/' + encodeURIComponent(id),
                reponedor,
                AuthService.setToken()
            )
            .then((res) => res.data?.data ?? res.data)
            .catch((e) => { console.log(e.message); throw e; });
    }

    /**
     * DELETE /reponedores/:id - elimina una asignación y sus relaciones
     * @param {number} id - ID de la asignación
     * @returns {Promise<Object>} Respuesta de la API
     */
    static async delete(id) {
        return axios
            .delete(HostService.getHost() + 'reponedores/' + encodeURIComponent(id), {
                ...AuthService.setToken()
            })
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e; });
    }
}

export default ReponedoresService;
